(ns minorodata.components.home-dashboard.toolbar
  (:require
   ["date-fns" :refer [addDays addMinutes]]
   ["lucide-react" :refer [ChevronDownIcon RefreshCcwIcon]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.utils :refer [format-date]]
   [minorodata.components.pipeline-editor.panel :refer [separator-with-text]]
   [re-posh.core :as re-posh]
   [ui.button :as button]
   [ui.datepicker :as datepicker]
   [ui.popover :as popover]
   [ui.tooltip :as tooltip]))

(defn set-timeframe [{:keys [from to]}]
  (dispatch [:analytics.events/set-timeframe {:from from
                                              :to   to}]))

(defn date-range-dropdown [{:keys [timeframe on-change]}]
  [popover/popover-root
   [popover/popover-trigger {:as-child false}
    [button/button {:variant   :secondary
                    :component :div
                    :icon-right ChevronDownIcon}
     (str (format-date (:from timeframe)) " - " (format-date (:to timeframe)))]]
   [popover/popover-content {:class "flex flex-col gap-4"}
    [:div {:class "flex gap-4 items-center"}
     [:strong "Last: "]
     [:div {:class "flex gap-1"}
      [button/button {:variant :secondary
                      :size :small
                      :on-click #(on-change {:from (addMinutes (js/Date.) -1440)
                                             :to   (js/Date.)})}
       "24 hours"]
      [button/button {:variant :secondary
                      :size :small
                      :on-click #(on-change {:from (addMinutes (js/Date.) -10080)
                                             :to   (js/Date.)})}
       "7 days"]
      [button/button {:variant :secondary
                      :size :small
                      :on-click #(on-change {:from (addMinutes (js/Date.) -43200)
                                             :to   (js/Date.)})}
       "30 days"]
      [button/button {:variant :secondary
                      :size :small
                      :on-click #(on-change {:from (addMinutes (js/Date.) -129600)
                                             :to   (js/Date.)})}
       "90 days"]]]

    [separator-with-text {:text "or"}]

    [datepicker/datetime-picker {:label     "Filter by date"
                                 :value     [(:from timeframe) (:to timeframe)]
                                 :min-date  (addDays (new js/Date) -90)
                                 :on-change #(on-change {:from (or (first %) (addDays (js/Date.) -7))
                                                         :to   (or (second %) (js/Date.))})}]]])

(defn time-select-dropdown []
  (let [timeframe @(re-posh/subscribe [:analytics.subs/timeframe])]
    [date-range-dropdown {:timeframe timeframe
                          :on-change set-timeframe}]))

(defn refresh-button [& [{:keys [on-refresh]}]]
  [tooltip/tooltip-root
   [tooltip/tooltip-trigger
    [button/button {:variant  :secondary
                    :size     :icon-md
                    :icon     RefreshCcwIcon
                    :on-click (or on-refresh #(dispatch [:analytics.events/refresh]))}]]
   [tooltip/tooltip-content "Refresh data"]])
